<template>
  <div role="alert" :class="['alert mb-4', $attrs.type, size]">
    <div class="flex items-start">
      <base-icon :icon="icon" :class="['alert_icon hidden lg:flex ml-1 leading-6', fontIcon]" />
      <div :class="['ml-2 lg:ml-3', font]">
        <span v-if="!hasLink">{{ text }}</span>
        <base-link v-else :to="$attrs.link">{{ text }}</base-link>
        <slot />
      </div>
      <div class="absolute h-full left-0 top-0 alert_border"></div>
    </div>
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'
import BaseLink from './_base-link.vue'
import {alertStyle} from '@/state/helpers/mixins.js'

export default {
  mixins: [alertStyle],

  components: {
    BaseIcon,
    BaseLink,
  },

  computed: {
    text() {
      switch (typeof this.$attrs.text) {
        case 'undefined':
          return ''
        case 'object':
          const {msg, part} = this.$attrs.text
          return this.$t(`mygwf.components.Alert.${msg}`, {part})
        default:
          return this.$t(`mygwf.components.Alert.${this.$attrs.text}`)
      }
    },
    hasLink() {
      return typeof this.$attrs.link !== 'undefined'
    },
    icon() {
      switch (this.$attrs.type) {
        case 'success':
          return 'success'
        case 'error':
          return 'info'
        case 'warn':
          return 'warn'
        default:
          return 'info'
      }
    },
  },
}
</script>

<style scoped>
.alert {
  @apply flex justify-start relative shadow leading-normal;

  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.alert.info {
  @apply text-blue-dark;
}

.alert.error {
  @apply text-red-dark;
}

.alert.warn {
  @apply text-orange-dark;
}

.alert.success {
  @apply text-green-dark;
}

.alert_border {
  width: 3px;
}

.alert:before {
  border-radius: inherit;
  bottom: 0;
  content: '';
  left: 0;
  opacity: 0.1;
  position: absolute;
  pointer-events: none;
  right: 0;
  top: 0;
}

.alert.info:before {
  @apply bg-blue-light;
}

.alert.error:before {
  @apply bg-red-light;
}

.alert.warn:before {
  @apply bg-orange-light;
}

.alert.success:before {
  @apply bg-green-light;
}

.alert.info .alert_border {
  @apply bg-blue-light;
}

.alert.error .alert_border {
  @apply bg-red-light;
}

.alert.warn .alert_border {
  @apply bg-orange-light;
}

.alert.success .alert_border {
  @apply bg-green-light;
}
</style>
